var _path, _path2, _path3, _path4;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgWaterTreatmentPlantWarning(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 31,
    height: 33,
    viewBox: "0 0 31 33",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M3 11.68C3 11.3044 3.32236 11 3.72 11H20.28C20.6776 11 21 11.3044 21 11.68V23.4516C21 23.6418 20.9157 23.8233 20.7675 23.952L12.4875 31.1464C12.2119 31.3859 11.7881 31.3859 11.5125 31.1464L3.23252 23.952C3.08433 23.8233 3 23.6418 3 23.4516V11.68Z",
    stroke: "#637381"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M3.63013 19.3304C3.63013 18.9548 3.95248 18.6504 4.35013 18.6504H19.5601C19.9578 18.6504 20.2801 18.9548 20.2801 19.3304V23.1152C20.2801 23.3035 20.1975 23.4834 20.0518 23.612L12.4892 30.2887C12.2135 30.532 11.7857 30.5331 11.5086 30.2911L3.86129 23.6123C3.71392 23.4836 3.63013 23.3026 3.63013 23.113V19.3304Z",
    fill: "#2486FD",
    fillOpacity: 0.2,
    stroke: "#1070CA",
    strokeOpacity: 0.2,
    strokeWidth: 0.5
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M24.5 11C24.5 13.4853 22.933 15.5 21 15.5C19.067 15.5 17.5 13.4853 17.5 11C17.5 8.51472 19.067 6.5 21 6.5C22.933 6.5 24.5 8.51472 24.5 11Z",
    fill: "white"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M14.7348 17.501H27.2848C28.5682 17.501 29.3682 16.1094 28.7265 15.001L22.4515 4.15938C21.8098 3.05104 20.2098 3.05104 19.5682 4.15938L13.2932 15.001C12.6515 16.1094 13.4515 17.501 14.7348 17.501ZM21.0098 11.6677C20.5515 11.6677 20.1765 11.2927 20.1765 10.8344V9.16771C20.1765 8.70937 20.5515 8.33437 21.0098 8.33437C21.4682 8.33437 21.8432 8.70937 21.8432 9.16771V10.8344C21.8432 11.2927 21.4682 11.6677 21.0098 11.6677ZM21.8432 15.001H20.1765V13.3344H21.8432V15.001Z",
    fill: "#FFAB00"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWaterTreatmentPlantWarning);
export default __webpack_public_path__ + "static/media/water_treatment_plant_warning.347dbbb7dce6d108d37569b7f8dfcbfc.svg";
export { ForwardRef as ReactComponent };